import { render } from "./FpuiButton.vue?vue&type=template&id=4c94b11e&lang=pug"
import script from "./FpuiButton.vue?vue&type=script&lang=js"
export * from "./FpuiButton.vue?vue&type=script&lang=js"

import "./FpuiButton.vue?vue&type=style&index=0&id=4c94b11e&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__